module.exports = __webpack_public_path__ + "img/图层 5.63bdf59d.png";